import dayjs from 'dayjs';
/**
 * compares if first date is before second date
 *
 * dates must be string that start with yyyy-MM-dd
 * @param first_date
 * @param second_date
 * @returns Boolean
 */
const isDateSooner = function (first_date: string, second_date: string) {
   return dayjs(first_date).format('YYYY-MM-DD') <= dayjs(second_date).format('YYYY-MM-DD');
};

const longDays: { [key: string]: Array<string> } = {
   nl: ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag'],
   en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
   fr: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
   de: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
};

const shortDays: { [key: string]: Array<string> } = {
   nl: ['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo'],
   en: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
   fr: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
   de: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
};

const today = dayjs();
const today_formatted = today.format('YYYY-MM-DD');

const tomorrow = dayjs().add(1, 'day');
const tomorrow_formatted = tomorrow.format('YYYY-MM-DD');

export { isDateSooner, longDays, shortDays, today, today_formatted, tomorrow, tomorrow_formatted };
